const intOrNull = (v) => (v ? parseInt(v, 10) : null);

const toMonths = (val, unit) => {
  const n = parseInt(val, 10);
  if (Number.isNaN(n) || n < 0) return null;
  return unit === "years" ? n * 12 : n;
};

const baseFields = (form, flags, lang) => {
  const owned = toMonths(form.owned_time, form.owned_unit) ?? 0;
  const ageAtPurchase = form.purchase_type === "used" ? (toMonths(form.age_at_purchase_time, form.age_at_purchase_unit) ?? 0) : null;
  return {
    category: form.category,
    brand: flags.resolvedBrand || "",
    model: flags.resolvedModel || "",
    purchase_price: form.purchase_price ? parseFloat(form.purchase_price) : null,
    original_retail_price: form.original_retail_price ? parseFloat(form.original_retail_price) : null,
    condition: form.condition,
    purchase_type: form.purchase_type,
    owned_months: owned,
    age_at_purchase_months: ageAtPurchase,
    age_months: owned + (ageAtPurchase || 0),
    urgency: form.urgency || null,
    usage_hours: intOrNull(form.usage_hours),
    material: flags.hasMaterial ? form.material : "",
    has_box: form.has_box,
    has_accessories: form.has_accessories,
    has_warranty: form.has_warranty,
    has_certificate: form.has_certificate,
    has_verifiable_serial: form.has_verifiable_serial,
    rarity: form.rarity || null,
    seasonality: form.seasonality || null,
    description: form.description,
    storage_gb: flags.hasStorage ? intOrNull(form.storage_gb) : null,
    item_size: flags.hasSize ? form.item_size : "",
    language: lang,
  };
};

const categoryFields = (form, flags) => ({
  kilometers: flags.isVehicle ? intOrNull(form.kilometers) : null,
  energy_class: flags.isAppliance && form.energy_class ? form.energy_class : null,
  repair_status: flags.isRepairable && form.repair_status ? form.repair_status : null,
  repair_details: flags.isRepairable ? form.repair_details : "",
});

const vehicleFields = (form, flags) => {
  const mv = flags.isMotorVehicle;
  return {
    service_history: mv && form.service_history ? form.service_history : null,
    recent_maintenance: mv ? form.recent_maintenance : "",
    body_condition: mv && form.body_condition ? form.body_condition : null,
    interior_condition: mv && form.interior_condition ? form.interior_condition : null,
    electronics_ok: mv && form.electronics_ok !== "" ? form.electronics_ok === "yes" : null,
    euro_class: mv && form.euro_class ? form.euro_class : null,
    fuel_type: mv && form.fuel_type ? form.fuel_type : null,
    battery_soh: mv && form.fuel_type === "electric" ? intOrNull(form.battery_soh) : null,
    engine_cc: mv ? intOrNull(form.engine_cc) : null,
    power_kw: mv ? intOrNull(form.power_kw) : null,
    owners_count: mv ? intOrNull(form.owners_count) : null,
    recent_inspection: mv ? form.recent_inspection : null,
  };
};

const bookFields = (form, flags) => ({
  book_edition: flags.isBook && form.book_edition ? form.book_edition : null,
  is_signed: flags.isBook ? form.is_signed : null,
  out_of_print: flags.isBook ? form.out_of_print : null,
  has_dust_jacket: flags.isBook ? form.has_dust_jacket : null,
  has_annotations: flags.isBook ? form.has_annotations : null,
});

const pcFields = (form, flags) => {
  const ct = flags.isPC ? (form.pc_component_type || null) : null;
  return {
    pc_component_type: ct,
    vram: ct === "gpu" ? (form.vram || "") : "",
    cpu_socket: ct === "cpu" ? (form.cpu_socket || "") : "",
    ram_storage_spec: ct === "ram" || ct === "storage" ? (form.ram_storage_spec || "") : "",
    gpu_usage: ct === "gpu" && form.gpu_usage ? form.gpu_usage : null,
    pc_build_specs: ct === "desktop" || ct === "laptop" ? (form.pc_build_specs || "") : "",
  };
};

export const buildValuationPayload = (form, flags, photoPaths, lang) => ({
  ...baseFields(form, flags, lang),
  ...categoryFields(form, flags),
  ...vehicleFields(form, flags),
  ...bookFields(form, flags),
  ...pcFields(form, flags),
  photos: photoPaths,
});
